module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-title"
  }, [_c('span', [_vm._v("BLUE YODEL 11")])]), _vm._v(" "), _c('p', {
    staticClass: "chap-subtitle1"
  }, [_c('span', [_vm._v("ABBO AND VAN")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ABBO")]), _vm._v(": You know that joke you told me? Why does it take longer for a woman …?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("VAN")]), _vm._v(": Yeah")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ABBO")]), _vm._v(": I’m telling it to Dean and Monte. Dean and Monte haven’t heard it. I’m telling it to Dean and Monte: “You know why it takes longer for a woman to reach orgasm than a man?” Right?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("VAN")]), _vm._v(": Right")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ABBO")]), _vm._v(": And Monte says, “No. Why?” Right?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("VAN")]), _vm._v(": Right")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ABBO")]), _vm._v(": And I start, “Who the f …” The punch line, right?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("VAN")]), _vm._v(": Right")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ABBO")]), _vm._v(": And Grace pops up. Grace. I don’t know where from. Around the corner. All of a sudden, Grace. Right? And I think")]), _vm._v(", rrrrrrk, “"), _c('i', [_vm._v("Grace does not want to hear this joke.” I’m right in the middle")]), _vm._v(" — “"), _c('i', [_vm._v("Who the f …")]), _vm._v("”—"), _c('i', [_vm._v("and here’s Grace and I’m thinking, “Grace will not like this joke.” Right?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("VAN")]), _vm._v(": Right")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ABBO")]), _vm._v(": And")]), _vm._v(" — "), _c('i', [_vm._v("but I’ve gone too far with it. I can’t think of some new second half of the punch line right on the spot that Grace won’t hate. Right?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("VAN")]), _vm._v(": Right")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ABBO")]), _vm._v(": I mean Grace is not a shrinking violet. Grace is, you know, you can hang out with Grace. Grace likes a joke. But I’m thinking, Grace may not")]), _vm._v(" — "), _c('i', [_vm._v("Grace won’t like this joke. Right?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("VAN")]), _vm._v(": Right. Even Grace")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ABBO")]), _vm._v(": Exactly! And it’s a shame! Even")]), _vm._v(" Grace "), _c('i', [_vm._v("won’t like this joke. And she")]), _vm._v(" should. "), _c('i', [_vm._v("Because, this joke")]), _vm._v(" — "), _c('i', [_vm._v("the thing is, a woman may not realize about this joke, that when a man tells this joke, he feels, like, the poignance of it. Right?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("VAN")]), _vm._v(": Absolutely")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ABBO")]), _vm._v(": And I’m talking")]), _vm._v(" — "), _c('i', [_vm._v("I mean the double-edge poignance. I mean this joke goes two ways! At least! It does! This is not a, you know, a like a pig joke. I mean, on the surface it is. And")]), _vm._v(" — "), _c('i', [_vm._v("hey, I like a good pig joke. But this")]), _vm._v(" — "), _c('i', [_vm._v("it")]), _vm._v(" sounds "), _c('i', [_vm._v("like, to a woman, it")]), _vm._v(" — "), _c('i', [_vm._v("that’s the problem")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("VAN")]), _vm._v(": Right there")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ABBO")]), _vm._v(": And the bad thing is, you know, Grace")]), _vm._v(" — "), _c('i', [_vm._v("I can’t, with Grace I can’t just stop in the middle and say “Woops,” you know, and she’ll understand it is not for her ears. Right?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("VAN")]), _vm._v(": Right. Not with Grace")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ABBO")]), _vm._v(": That’s the thing. With Grace")]), _vm._v(" — "), _c('i', [_vm._v("she likes a joke. You can say")]), _vm._v(" — "), _c('i', [_vm._v("like, for instance, here’s a joke I told to Grace")]), _vm._v(". No, "), _c('i', [_vm._v("wait! Grace told this joke to")]), _vm._v(" me. "), _c('i', [_vm._v("The joke, you know, the black guy goes into the Cadillac dealer, right?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("VAN")]), _vm._v(": Yeah?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ABBO")]), _vm._v(": You didn’t hear this joke? Black guy goes into a Cadillac dealer, you know, walks in, and the guy in the showroom")]), _vm._v(" — "), _c('i', [_vm._v("very snotty, right, the guy looks at this black guy, and, you know, we’re talking")]), _vm._v(" new "), _c('i', [_vm._v("Cadillacs, right?")]), _vm._v(" — "), _c('i', [_vm._v("and the guy says to the black guy, snotty, “Uhhm, are you thinking about buying a Cadillac?")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("VAN")]), _vm._v(": Yeah")]), _vm._v(" …")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ABBO")]), _vm._v(": And the black guy looks at the guy in the showroom, right… and says: “I’m")]), _vm._v(" gonna "), _c('i', [_vm._v("buy a Cadillac. I’m")]), _vm._v(" thinking "), _c('i', [_vm._v("about pussy")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("VAN")]), _vm._v(": Oh yeah, right, right")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ABBO")]), _vm._v(": And anyway, Grace")]), _vm._v(" told me "), _c('i', [_vm._v("that joke. So Grace is not somebody who doesn’t like a joke. With, like, pussy in it or anything. Right?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("VAN")]), _vm._v(": Yeah. Grace …")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ABBO")]), _vm._v(": Right. So, but anyway")]), _vm._v(" — "), _c('i', [_vm._v("this is … talk about")]), _vm._v(" poignant. "), _c('i', [_vm._v("This is a terrible moment. Because")]), _vm._v(" I want Grace to hear this joke. "), _c('i', [_vm._v("But I’m")]), _vm._v(" afraid. "), _c('i', [_vm._v("I’m afraid Grace will hate it! And I don’t want to tell a joke Grace will hate! And")]), _vm._v(" — "), _c('i', [_vm._v("the terrible thing is, now, I’m right in the middle of the punch line, “Who the f…,” right?")]), _vm._v(" — "), _c('i', [_vm._v("and")]), _vm._v(" I … "), _c('i', [_vm._v("pause. ’Cause I saw Grace. Right?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("VAN")]), _vm._v(": Right")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ABBO")]), _vm._v(": So now I’m dead. Grace heard me pause. She also heard the joke. So far. So")]), _vm._v(" where is my way out?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("VAN")]), _vm._v(": Yeah")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ABBO")]), _vm._v(": You can’t stop in the middle and start saying to Grace, “Wait a minute, Grace")]), _vm._v(" — "), _c('i', [_vm._v("before I finish this punch line, you ought to know, this is a joke that I’m aware")]), _vm._v(" — "), _c('i', [_vm._v("I mean, this is a joke men tell each other and it, I mean, it does sort of strike at a certain male")]), _vm._v("… knot "), _c('i', [_vm._v("or something, but")]), _vm._v(" — "), _c('i', [_vm._v("I mean men hear it and break up and it gives them a certain")]), _vm._v(" release … "), _c('i', [_vm._v("but")]), _vm._v(" men see the double-edge poignance of it.” "), _c('i', [_vm._v("Right? You can’t")]), _vm._v(" say "), _c('i', [_vm._v("that in the middle of a joke. You can’t say that")]), _vm._v(" after "), _c('i', [_vm._v("a joke. You can’t say that")]), _vm._v(" before "), _c('i', [_vm._v("a joke. Right?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("VAN")]), _vm._v(": Right")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ABBO")]), _vm._v(": Because, for one thing")]), _vm._v(" — "), _c('i', [_vm._v("just because men see the double-edge poignance of it, doesn’t mean that they want to")]), _vm._v(" let on "), _c('i', [_vm._v("that they do. That’d defeat the whole")]), _vm._v(" … "), _c('i', [_vm._v("I mean you start")]), _vm._v(" concentrating "), _c('i', [_vm._v("on the double-edge poignance and you’re right back into the knot. Hey!")]), _vm._v(" A woman ought to be able to hear this joke. "), _c('i', [_vm._v("And like it. In a way. But she won’t. Even Grace. Right?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("VAN")]), _vm._v(": Even Grace")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ABBO")]), _vm._v(": So, what I do")]), _vm._v(" — "), _c('i', [_vm._v("I can’t stop and blush and run off. That’d be worse. I’ve got to push on through. I pause for a split second. And I look at Grace, who’s expectant but is also sort of angling her head, you know, angling it and pulling it back slightly while looking at me out of one eye")]), _vm._v(" — "), _c('i', [_vm._v("you know,")]), _vm._v(" “"), _c('i', [_vm._v("What is this I’m hearing?")]), _vm._v("”—"), _c('i', [_vm._v("and from Grace, I hate to see that look")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("VAN")]), _vm._v(": Because Grace")]), _vm._v("… "), _c('i', [_vm._v("Yeah")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ABBO")]), _vm._v(": But I push on through. I push on through with, you know, the punch line: “Who the")]), _vm._v(" fuck … cares?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("VAN")]), _vm._v(": Right")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ABBO")]), _vm._v(": And I wind up looking, with this sick smile, I wind up looking at Grace")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("VAN")]), _vm._v(": Yeah?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ABBO")]), _vm._v(": And Grace didn’t like it")]), _vm._v(".")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44a404da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book1/xhtml/chapter20.vue
// module id = 147
// module chunks = 0